export default "__VITE_ASSET__40af107a__"